// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.2_esbuild@0.25.9_postcss@8.5.6_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.2_esbuild@0.25.9_postcss@8.5.6_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 24px;
  gap: 14px;
  background-color: var(--fourth-bg);
  border-radius: 16px;
  margin-top: 8px;
}
.empty-state .empty-state-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: rgba(254, 83, 38, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  color: var(--primary);
}
.empty-state .empty-state-title {
  font-weight: 700;
  color: var(--black);
  margin: 0;
}
.empty-state .empty-state-msg {
  color: #6c757d;
  font-size: 14px;
  max-width: 300px;
  margin: 0;
  line-height: 1.6;
}
.empty-state .empty-state-msg strong {
  color: var(--black);
}
.empty-state .empty-state-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 4px;
}
.empty-state .empty-state-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 22px;
  border-radius: 160px;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: 0.3s ease;
  border: 1px solid transparent;
}
.empty-state .empty-state-btn--filled {
  background-color: var(--primary);
  color: var(--white);
  border-color: var(--primary);
}
.empty-state .empty-state-btn--filled:hover {
  background-color: color-mix(in srgb, var(--primary) 85%, black);
  color: var(--white);
}
.empty-state .empty-state-btn--outline {
  background-color: transparent;
  color: var(--secondary);
  border-color: var(--secondary);
}
.empty-state .empty-state-btn--outline:hover {
  background-color: var(--secondary);
  color: var(--white);
}

.theme-select:focus {
  border-color: #0099e5 !important;
  box-shadow: 0 0 0 0.1rem rgba(0, 153, 229, 0.25);
}

.category-item:hover {
  background-color: #0099e5;
  cursor: pointer;
}

details[open] summary i {
  transform: rotate(180deg);
  transition: transform 0.3s;
}

summary i {
  transition: transform 0.3s;
}`, "",{"version":3,"sources":["webpack://./src/app/components/phone-cases/phone-cases.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,kCAAA;EACA,mBAAA;EACA,eAAA;AACJ;AACI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;AACR;AAEI;EACI,gBAAA;EACA,mBAAA;EACA,SAAA;AAAR;AAGI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;AADR;AAGQ;EACI,mBAAA;AADZ;AAKI;EACI,aAAA;EACA,SAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;AAHR;AAMI;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;EACA,6BAAA;AAJR;AAMQ;EACI,gCAAA;EACA,mBAAA;EACA,4BAAA;AAJZ;AAMY;EACI,+DAAA;EACA,mBAAA;AAJhB;AAQQ;EACI,6BAAA;EACA,uBAAA;EACA,8BAAA;AANZ;AAQY;EACI,kCAAA;EACA,mBAAA;AANhB;;AAYA;EACI,gCAAA;EACA,gDAAA;AATJ;;AAYA;EACI,yBAAA;EACA,eAAA;AATJ;;AAYA;EACI,yBAAA;EACA,0BAAA;AATJ;;AAYA;EACI,0BAAA;AATJ","sourcesContent":[".empty-state {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding: 48px 24px;\n    gap: 14px;\n    background-color: var(--fourth-bg);\n    border-radius: 16px;\n    margin-top: 8px;\n\n    .empty-state-icon {\n        width: 80px;\n        height: 80px;\n        border-radius: 50%;\n        background-color: rgba(254, 83, 38, 0.1);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 36px;\n        color: var(--primary);\n    }\n\n    .empty-state-title {\n        font-weight: 700;\n        color: var(--black);\n        margin: 0;\n    }\n\n    .empty-state-msg {\n        color: #6c757d;\n        font-size: 14px;\n        max-width: 300px;\n        margin: 0;\n        line-height: 1.6;\n\n        strong {\n            color: var(--black);\n        }\n    }\n\n    .empty-state-actions {\n        display: flex;\n        gap: 10px;\n        flex-wrap: wrap;\n        justify-content: center;\n        margin-top: 4px;\n    }\n\n    .empty-state-btn {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        padding: 10px 22px;\n        border-radius: 160px;\n        font-size: 14px;\n        font-weight: 500;\n        text-decoration: none;\n        cursor: pointer;\n        transition: 0.3s ease;\n        border: 1px solid transparent;\n\n        &--filled {\n            background-color: var(--primary);\n            color: var(--white);\n            border-color: var(--primary);\n\n            &:hover {\n                background-color: color-mix(in srgb, var(--primary) 85%, black);\n                color: var(--white);\n            }\n        }\n\n        &--outline {\n            background-color: transparent;\n            color: var(--secondary);\n            border-color: var(--secondary);\n\n            &:hover {\n                background-color: var(--secondary);\n                color: var(--white);\n            }\n        }\n    }\n}\n\n.theme-select:focus {\n    border-color: #0099e5 !important;\n    box-shadow: 0 0 0 0.1rem rgba(0, 153, 229, 0.25);\n}\n\n.category-item:hover {\n    background-color: #0099e5;\n    cursor: pointer;\n}\n\ndetails[open] summary i {\n    transform: rotate(180deg);\n    transition: transform 0.3s;\n}\n\nsummary i {\n    transition: transform 0.3s;\n}\n\n\n//.sub-banner {\n//    //background: url('/assets/website-images/Inner_Page_Banner_Image_1920_570.jpg') no-repeat center center;\n//    background-size: cover;\n//    height: 400px;\n//    display: flex;\n//    align-items: center;\n//    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n//    justify-content: center;\n//    position: relative;\n//    margin-top: 53px;\n//\n//    &:before {\n//        content: '';\n//        position: absolute;\n//        top: 0;\n//        left: 0;\n//        background: rgba(0, 0, 0, 0.4);\n//        width: 100%;\n//        height: 100%;\n//    }\n//\n//    & .banner-header {\n//        font-size: 60px;\n//        color: var(--tertiary);\n//        font-weight: 600;\n//        position: relative;\n//        z-index: 1;\n//        margin: 0;\n//        line-height: normal;\n//        padding: 0 20px;\n//        font-family: \"Poppins\", sans-serif;\n//    }\n//}\n//@media screen and (max-width: 1199px) {\n//    .sub-banner {\n//        height: 300px;\n//\n//        & .banner-header {\n//            font-size: 40px;\n//        }\n//    }\n//}\n//\n//@media screen and (max-width: 768px) {\n//    .sub-banner {\n//        height: 250px;\n//\n//        & .banner-header {\n//            font-size: 30px;\n//        }\n//    }\n//\n//}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
